import {ZWebCommons} from '@zetti/zweb-react-commons';
import {ZWebResources} from "./ZWebRepository";

const ZWebReactCommons = new ZWebCommons({
  resources: ZWebResources
});

export default ZWebReactCommons